/**
 * Emit a custom event
 * @param  {String} type   The event type
 * @param  {*}      detail Any details to pass along with the event
 * @param  {Node}   elem   The element to emit the event on
 */
export default function emit(type: string, detail: any, elem: Node = document) {
  // Create a new event
  const event = new CustomEvent(type, {
    bubbles: true,
    cancelable: true,
    detail,
  });

  // Dispatch the event
  return elem.dispatchEvent(event);
}
